module.exports = __webpack_public_path__ + "static/img/7.d4761676.png";